/**
 * Shared helpers for StaticRouter location when rendering SSR at the site root.
 */

export function resolveBasenameFromPath(_pathname: string): undefined {
  return undefined;
}

/**
 * Path as seen by React Router (strip basename prefix from the request path).
 */
export function resolveStaticRouterLocation(requestPath: string, basename?: string): string {
  const [pathPart, ...restQ] = requestPath.split('?');
  const query = restQ.length > 0 ? restQ.join('?') : '';
  const path = pathPart || '/';
  if (!basename) {
    return query ? `${path}?${query}` : path;
  }
  const base = basename.endsWith('/') ? basename.slice(0, -1) : basename;
  if (path === base || path.startsWith(`${base}/`)) {
    const rest = path === base ? '/' : path.slice(base.length) || '/';
    const withSlash = rest.startsWith('/') ? rest : `/${rest}`;
    return query ? `${withSlash}?${query}` : withSlash;
  }
  return query ? `${path}?${query}` : path;
}
